import React from 'react';
import propTypes from 'prop-types';
import './successPayment.scss';

export const SuccessPaymentIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      className={`payment-checkmark-icon-container ${variant}`}
      width={sizeInPixel}
      height={sizeInPixel}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
      style={{ boxShadow: `inset 0px 0px 0px ${color}` }}
      stroke={color}
    >
      <circle
        className="checkmark__circle"
        cx="26"
        cy="26"
        r="25"
        stroke={color}
        fill="none"
      />
      <path
        className="checkmark__check"
        fill="none"
        d="M14.1 27.2l7.1 7.2 16.7-16.8"
      />
    </svg>
  );
};
SuccessPaymentIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
SuccessPaymentIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
